<template>
  <HomeView />
</template>

<script>
import HomeView from "@/components/Home";
export default {
  components: {
    HomeView,
  },
  name: "Home",
};
</script>
